module.exports = __webpack_public_path__ + "static/img/img-install-tag-car.1d0f5e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car.svg
// module id = 1793
// module chunks = 1